/** Synthetic trip id for all-trips timeline mode (UI / Redux). */
export const ALL_TRIPS_TRIP_ID = '__all__';

/** API token for all-trips timeline requests (Nest TTA contract). */
export const TTA_ALL_TRIPS_OBSERVED_TRIP_ID = 'all';

export const DEFAULT_ON_TIME_LOWER_SECONDS = -60;
export const DEFAULT_ON_TIME_UPPER_SECONDS = 60;

export const MIN_ON_TIME_BOUND_SECONDS = -600;
export const MAX_ON_TIME_BOUND_SECONDS = 600;
export const ON_TIME_WINDOW_STEP_SECONDS = 5;

/** Nest TTA module base path (see PRD-3266). */
export const TTA_API_BASE_PATH = '/tta';
